import React, { Fragment, useCallback } from "react";

import * as dfn from "date-fns/fp";
// //devextreme
import List from "devextreme-react/list";
import ArrayStore from "devextreme/data/array_store";
//helpers
import size from "lodash/size";
import { useDebouncedCallback } from "use-debounce";

import { Case, CaseElse, Switch, useWindowDimensions } from "@app/contexts";
// import { useHelpContext } from '@app/context';
import eventEmitter from "@app/contexts/emitter";
import {
  CONST_LISTORIGIN_INVOICE,
  CONST_LISTORIGIN_PROFORMA,
  CONST_LISTORIGIN_WORK,
  CONST_LSTGRP_DICTIONARY,
  CONST_LSTGRP_SELECTIE,
} from "@app/state/insider/constants";
import { select_api_login_amaid } from "@app/state/insider/login";
import {
  listReportsSetTempUiKV,
  selectListReportUi_iems,
  slectListReportLoadedID,
} from "@app/state/insider/ui/uiList";
// import '@app/style/dx.generic.jurnalKarma1.css';
// import '@app/style/dx.generic.teamZebra.css';
import "@app/style/dx.generic.karmaGunMetal.css";

import { useAppDispatch, useAppSelector } from "../../state";
import { SelAsListItem4Contacts } from "./criteria";
import "./lists_common.scss";
import { localInvoices, localMywo } from "./optionPanels";

const forcedDefaultInterval = {
  start: dfn.format(
    "yyyy-MM-dd",
    new Date(dfn.startOfMonth(dfn.subYears(1, new Date())))
  ),
  end: dfn.format("yyyy-MM-dd", new Date()),
};

export const ListOfReports_ = () => {
  const { selectedTab, uSelectedPeriod, gSelectedPeriod } = localMywo;
  const { selectedCurrency, selectedEmitent } = localInvoices;
  const dispatch = useAppDispatch();
  const { height: fullHeight } = useWindowDimensions();
  const theListDetails = useAppSelector(selectListReportUi_iems);
  const lxReportIDLoaded = useAppSelector(slectListReportLoadedID);
  const theAmaId = useAppSelector(select_api_login_amaid);
  const debouncedDispatch = useDebouncedCallback(
    (action) => dispatch(action),
    700,
    { leading: true }
  );

  const dataDetailsOptions = {
    store: new ArrayStore({
      data: theListDetails,
      key: "id",
    }),
    group: "displayGroup",
    searchExpr: ["name"],
    paginate: false,
    postProcess: (data: any) => {
      // sort the groups
      const dt: any = Object.assign({}, CONST_LSTGRP_DICTIONARY);
      const out: any[] = [];
      data.forEach((item: any) => {
        dt[item.key] = item.items;
      });
      Object.keys(dt).forEach((key) => {
        if (dt[key] && Array.isArray(dt[key])) {
          out.push({ key, items: dt[key] });
        }
      });
      return out;
    },
  };

  const showListDetails = (e: any) => {
    e.stopPropagation();
    const id = e?.target?.dataset?.id;
    const rName = e?.target?.dataset?.name;

    const args = {};

    if (rName.includes(CONST_LISTORIGIN_WORK)) {
      //[findme##438##] duplicate code - change both//
      Object.assign(args, {
        ama: selectedTab === "USER" ? theAmaId : 0,
        start:
          selectedTab === "USER"
            ? uSelectedPeriod.start
            : gSelectedPeriod.start,
        end: selectedTab === "USER" ? uSelectedPeriod.end : gSelectedPeriod.end,
        watch: false,
      });
    }
    if (rName.includes(CONST_LISTORIGIN_PROFORMA)) {
      //[findme##937##] duplicate code - change both//
      Object.assign(args, {
        ama: theAmaId,
        currency: selectedCurrency,
        watch: false,
      });
    }
    if (rName.includes(CONST_LISTORIGIN_INVOICE)) {
      //[findme##1030##] duplicate code - change both//
      Object.assign(args, {
        ama: theAmaId,
        emitent: selectedEmitent,
        watch: false,
      });
    }
    if (id) {
      debouncedDispatch(
        listReportsSetTempUiKV({
          lxReportId: +id,
          lxReportName: rName,
          "::sender": "showListDetails",
          // dudeee ///
          args: args,
        })
      );
    }
  };

  function renderDetailListItem(item: any) {
    if ([-100].includes(item.id)) {
      return <div className={"hidden-item"} />;
    }
    return (
      <div className={"lil lildetail"}>
        <div className={"lil-icon"}>
          {item.name ? (
            <div
              className={`div-icon-doc ${
                lxReportIDLoaded === item.id ? "selected-icon" : ""
              }`}
            />
          ) : (
            <Fragment />
          )}
        </div>
        <div className={"lil-title"}>
          <div className={"lil-name"}>{item.displayName}</div>
        </div>
        <div className={"lil-footer"}>{item.text}</div>
        <button
          className={"lil-show-details"}
          data-id={+item.id}
          data-name={item.name}
          onKeyUp={showListDetails}
          onClick={showListDetails}
        />
      </div>
    );
  }
  const groupRenderDetailGroupHeader = (item: any) => {
    const key: keyof typeof CONST_LSTGRP_DICTIONARY = item.key;
    return (
      <Switch value={item.key}>
        <Case when={CONST_LSTGRP_SELECTIE}>
          <Switch value={item.items[0].group}>
            <Case when={1}>
              <SelAsListItem4Contacts />
            </Case>
            <CaseElse>
              <div>{"Criterii pentru generarea listei"}</div>
            </CaseElse>
          </Switch>
        </Case>
        <CaseElse>
          <div className={"lildetail-group"}>
            {CONST_LSTGRP_DICTIONARY[key]} <span className={"bat"}>|</span>
            {size(item.items.filter((u: any) => u.name))}
          </div>
        </CaseElse>
      </Switch>
    );
  };
  const handleListDetailsSelectionChange = useCallback((e: any) => {
    const currentList = e.addedItems[0];
    if (currentList?.id === undefined) {
      return;
    }
    dispatch(
      listReportsSetTempUiKV({
        lxReportId: currentList.id,
        lxReportName: currentList.name,
        "::sender": "handleListDetailsSelectionChange",
      })
    );
  }, []);

  const hideHelp = useCallback(() => {
    //we choose the emmiter because the context hook causes a re-render
    eventEmitter.emit("HELP_PAGE_SHOW", { list: false });
  }, []);

  return (
    <List
      id={"list-of-details"}
      className={"dx-swatch-karmaGunMetal"}
      height={fullHeight ?? 0}
      selectionMode="single"
      dataSource={dataDetailsOptions}
      grouped={true}
      searchEnabled={false}
      onSelectionChanged={handleListDetailsSelectionChange}
      itemRender={renderDetailListItem}
      groupRender={groupRenderDetailGroupHeader}
      onItemClick={hideHelp}
      focusStateEnabled={false}
      collapsibleGroups={true}
      repaintChangesOnly={true}
      noDataText={""}
    />
  );
};
export const ListOfReports = React.memo(ListOfReports_);
